const NUMBER_MAX_LIMIT = Number.MAX_VALUE;
const ELEC_PRICE_PROPORTION = 5400;
export const Const = {
    NUMBER_MAX_LIMIT: NUMBER_MAX_LIMIT,
    validationMessage : {
        NaN: "Phải là số",
        exceedNumberLimit: (max = NUMBER_MAX_LIMIT) => "Số quá lớn",
        exceedTextLimit: (limit) => {
            return `Tối đa ${limit} ký tự`;
        },
        required: "Trường này là bắt buộc",
        elecPriceExceedLimit: () => `Tiền điện phải nhỏ hơn tiêu thụ điện * ${ELEC_PRICE_PROPORTION}`,
        reportLight: {
            name: {
                required: "Vui lòng nhập tên đèn"
            },
            isLed: {
                required: "Vui lòng chọn 'Có phải đèn LED không?'"
            },
            quantity: {
                required: "Vui lòng nhập số lượng"
            },
            ratedPower: {
                required: "Vui lòng nhập công suất định mức"
            },
            avgLightHour: {
                required: "Vui lòng nhập số giờ thắp sáng trung bình"
            },
            dayUse: {
                required: "Vui lòng nhập số ngày sử dụng"
            },
        },
        reportAirConditioner: {
            manufacturerName: {
              required: "Vui lòng nhập hãng sản xuất"  
            },
            coolingCapacity: {
                required: "Vui lòng nhập công suất lạnh"
            },
            isInverter: {
                required: "Vui lòng chọn 'Đã có inverter hay chưa?'"
            },
            quantity: {
                required: "Vui lòng nhập số lượng"
            },
            ratedPower: {
                required: "Vui lòng nhập công suất định mức"
            },
            avgHourUse: {
                required: "Vui lòng nhập số giờ thắp sáng trung bình"
            },
            dayUse: {
                required: "Vui lòng nhập số ngày sử dụng"
            },
        },
        reportPump: {
            intenedUse: {
                required: "Vui lòng nhập mục đích sử dụng"
            },
            typePump: {
                required: "Vui lòng chọn 'Kiểu bơm'"
            },
            quantity: {
                required: "Vui lòng nhập số lượng"
            },
            yearInstall: {
                required: "Vui lòng chọn năm cài đặt"
            },
            ratedPower: {
                required: "Vui lòng nhập công suất định mức"
            },
            avgHourUse: {
                required: "Vui lòng nhập số giờ sử dụng trung bình"
            },
            dayUse: {
                required: "Vui lòng nhập số ngày sử dụng"
            },
            currentStatus: {
                required: "Vui lòng chọn hiện trạng"
            }
        },
        reportFan: {
            intenedUse: {
                required: "Vui lòng nhập mục đích sử dụng"
            },
            typeFan: {
                required: "Vui lòng chọn 'Kiểu quạt'"
            },
            quantity: {
                required: "Vui lòng nhập số lượng"
            },
            yearInstall: {
                required: "Vui lòng chọn năm cài đặt"
            },
            ratedPower: {
                required: "Vui lòng nhập công suất định mức"
            },
            avgHourUse: {
                required: "Vui lòng nhập số giờ sử dụng trung bình"
            },
            dayUse: {
                required: "Vui lòng nhập số ngày sử dụng"
            },
            currentStatus: {
                required: "Vui lòng chọn hiện trạng"
            }
        },
        reportElevator: {
            intenedUse: {
                required: "Vui lòng nhập mục đích sử dụng"
            },
            typeElevator: {
                required: "Vui lòng chọn 'Kiểu thang máy'"
            },
            quantity: {
                required: "Vui lòng nhập số lượng"
            },
            yearInstall: {
                required: "Vui lòng chọn năm cài đặt"
            },
            ratedPower: {
                required: "Vui lòng nhập công suất định mức"
            },
            avgHourUse: {
                required: "Vui lòng nhập số giờ sử dụng trung bình"
            },
            dayUse: {
                required: "Vui lòng nhập số ngày sử dụng"
            },
            // currentStatus: {
            //     required: "Vui lòng chọn hiện trạng"
            // }
        },
        reportOtherEngine: {
            intenedUse: {
                required: "Vui lòng nhập mục đích sử dụng"
            },
            deviceName: {
                required: "Vui lòng nhập tên động cơ"
            },
            quantity: {
                required: "Vui lòng nhập số lượng"
            },
            yearInstall: {
                required: "Vui lòng chọn năm cài đặt"
            },
            ratedPower: {
                required: "Vui lòng nhập công suất định mức"
            },
            avgHourUse: {
                required: "Vui lòng nhập số giờ sử dụng trung bình"
            },
            dayUse: {
                required: "Vui lòng nhập số ngày sử dụng"
            },
            // currentStatus: {
            //     required: "Vui lòng chọn hiện trạng"
            // }
        },
        reportOffice: {
            deviceName: {
                required: "Vui lòng nhập tên thiết bị"
            },
            quantity: {
                required: "Vui lòng nhập số lượng"
            },
            ratedPower: {
                required: "Vui lòng nhập công suất định mức"
            },
            avgHourUse: {
                required: "Vui lòng nhập số giờ sử dụng trung bình"
            },
            dayUse: {
                required: "Vui lòng nhập số ngày sử dụng"
            },
        },
        reportInductionStove: {
            deviceName: {
                required: "Vui lòng nhập tên bếp"
            },
            quantity: {
                required: "Vui lòng nhập số lượng"
            },
            ratedPower: {
                required: "Vui lòng nhập công suất định mức"
            },
            avgHourUse: {
                required: "Vui lòng nhập số giờ sử dụng trung bình"
            },
            dayUse: {
                required: "Vui lòng nhập số ngày sử dụng"
            },
        }
    },
    actionMessage: {
        updateSuccessfully: "Cập nhật thành công"
    },
    reportPump: {
        currentStatus: {
            fixedPumpNoVfdUnder50: 5, // Chưa lắp biến tần, nhưng bơm lưu lượng cố định ở mức dưới 50% tải.
            variedPumpNoVfd: 6, // Chưa lắp biến tần, nhưng lưu lượng nước điều chỉnh thay đổi bằng van tuỳ thời điểm
        }
    },
    reportFan: {
        currentStatus: {
            fixedFanNoVfdUnder50: 5, // Chưa lắp biến tần, nhưng quạt lưu lượng cố định ở mức dưới 50% tải.
            variedFanNoVfd: 6, // Chưa lắp biến tần, nhưng lưu lượng gió điều chỉnh thay đổi tuỳ thời điểm
        }
    },
    reportAirConditioner: {
        typeAirCondition: {
            local: 3
        }
    },
    report: {
        numPrice: {
            onePrice: "0",
            threePrice: "1"
        },
        // Giá điện cao nhất  
        ELEC_PRICE_PROPORTION: 5400  
    },
    emissionFactor: {
        co2kWh: 0.0006592
    },
    groupFuel: {
        electricity: 1,
        other: 39,
        moneyBuyReactivePower: 1036
    },
    deFuel: {
        elecBuy: 1,
        elecManufacture: 1020,
        elecSell: 1021,
    },
    fuelUnitToe: {
        fuel: 1,
        groupFuel: 2
    },
    paypackPeriod: {
        reportLight: 1.5,
        reportAirConditioner: 3.2,
        reportFanSolutionUseHighPerformance: 3.8,
        reportFanSolutionSmallerFan: 1.5,
        reportFanSolutionInverter: 1.8,
        reportPumpSolutionUseHighPerformance: 3.8,
        reportPumpSolutionSmallerPump: 1.5,
        reportPumpSolutionInverter: 1.8,
        ems: 3,
        training: 1,
    }
}